module.exports = __webpack_public_path__ + "static/media/avatar_1.b6e8e30a.png";